import { Card } from "../../models/card";
export class Fire extends Card {
}
Fire.displayName = "Fire";
Fire.artUrl = "./assets/cards/fire.jpg";
